// extracted by mini-css-extract-plugin
var _1 = "FileTableAttachments-moduleFileTableAttachments___eW2G";
export { _1 as "FileTableAttachments" }
